/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ clock: NonNullable<unknown> }} Workout_ElapsedInputs */

const en_us2_workout_elapsed = /** @type {(inputs: Workout_ElapsedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Workout time: ${i?.clock}`)
};

const pt_br2_workout_elapsed = /** @type {(inputs: Workout_ElapsedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tempo de treino: ${i?.clock}`)
};

const es_419_workout_elapsed = /** @type {(inputs: Workout_ElapsedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tiempo de entrenamiento: ${i?.clock}`)
};

const pt_pt2_workout_elapsed = /** @type {(inputs: Workout_ElapsedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tempo de treino: ${i?.clock}`)
};

const fr_fr2_workout_elapsed = /** @type {(inputs: Workout_ElapsedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Durée de séance : ${i?.clock}`)
};

const de_de2_workout_elapsed = /** @type {(inputs: Workout_ElapsedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Trainingszeit: ${i?.clock}`)
};

const it_it2_workout_elapsed = /** @type {(inputs: Workout_ElapsedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tempo di allenamento: ${i?.clock}`)
};

/**
* | output |
* | --- |
* | "Workout time: {clock}" |
*
* @param {Workout_ElapsedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_elapsed = /** @type {((inputs: Workout_ElapsedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_ElapsedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_elapsed(inputs)
	if (locale === "es-419") return es_419_workout_elapsed(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_elapsed(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_elapsed(inputs)
	if (locale === "de-DE") return de_de2_workout_elapsed(inputs)
	if (locale === "it-IT") return it_it2_workout_elapsed(inputs)
	return en_us2_workout_elapsed(inputs)
});
export { workout_elapsed as "workout.elapsed" }